import { type RefObject, useEffect } from 'react';

export const useResizeObserver = ({
  callback,
  ref,
  elem,
  enabled = true,
}: {
  callback: ResizeObserverCallback;
  ref?: RefObject<any>;
  elem?: HTMLElement | null;
  enabled?: boolean;
}) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const observer = new ResizeObserver(callback);

    if (ref?.current) {
      observer.observe(ref.current);
    }
    if (elem) {
      observer.observe(elem);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref, elem, callback, enabled]);
};
